// extracted by mini-css-extract-plugin
module.exports = {"collapsed":"jut__Collapse__collapsed","show":"jut__Collapse__show","collapsing":"jut__Collapse__collapsing"};